<template>
    <div>
        <a-tabs default-active-key="1" @change="callback">
            <a-tab-pane key="1" tab="语言列表">
                <LanguageList></LanguageList>
            </a-tab-pane>
            <a-tab-pane key="2" tab="字段列表" force-render>
                <FieldList></FieldList>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
    import LanguageList from "./components/languageList"
    import FieldList from "./components/fieldList"
    export default {
        name: "index",
        data() {
            return {};
        },
        created() {
            this.$store.state.adminleftnavnum = "/UserBackground/LanguagePack"; //设置左侧导航2-2 active
        },
        components:{FieldList,LanguageList},
        methods: {
            callback(key) {
            },
        },
    }
</script>

<style scoped>

</style>
